var fields = [
    {
        fieldId: "message",
        validators: [ValidateMessage],
        isValid: null
    },
    {
        fieldId: "email",
        validators: [ValidateEmail],
        isValid: null
    }
];

fields.forEach(t => {
    var element = document.getElementById(t.fieldId);
    element.addEventListener("keyup", function(e) {
        var isValid = true;

        t.validators.forEach(n => {
            if(!n()) isValid = false;
        });

        t.isValid = isValid;

        ValidateForm();
    }, false);
});

/**
 * Validate contact us form message.
 */
function ValidateMessage(){
    const messageField = document.getElementById("message");
    const msg = messageField.value;
    
    if(msg.length !== 0) {
        messageField.classList.remove("invalid");

        return true;
    } else {
        messageField.classList.add("invalid");		
        
        return false;
    }
}

/**
 * Validate contact us form Email.
 * @returns Validity
 */
function ValidateEmail() {
    const emailField = document.getElementById("email");
    const emailValue = emailField.value;
    
    const validateEmail = (email) => {
        return email.match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
      };
    if (validateEmail(emailValue)) {
        emailField.classList.remove("invalid");

        return true;
    } else {
        emailField.classList.add("invalid");	

        return false;		
    }

}

/**
 * Validates contact us form.
 */
function ValidateForm(){
    var isValid = true;

    for(var i = 0; i < fields.length; i++) {
        if(!fields[i].isValid) {
            isValid = false;
            break;
        }
    }

    const sumbitButton = document.getElementById('btnSubmit');
    sumbitButton.disabled = !isValid;
}
